// src/utils/legacyLinkResolver.js
import { useEffect, useState } from 'react';
import { Release } from '../models/Release';

const DEBUG = true;
const log = (...a) => DEBUG && console.log('[LegacyResolver]', ...a);

export function useLegacyLinkResolver({ isLegacyPath, flatToc }) {
    /* Rückgabestatus --------------------------------------------------- */
    const [waiting, setWaiting] = useState(isLegacyPath);

    /* <base href="/Content/"> berücksichtigen -------------------------- */
    const baseHref = (() => {
        const href = document.querySelector('base')?.getAttribute('href') ?? '/';
        return href.endsWith('/') ? href.slice(0, -1) : href;   // "", "/Content", …
    })();

    useEffect(() => {
        if (!isLegacyPath) {
            setWaiting(false);          // kein Legacy-Pfad ⇒ nichts zu tun
            return;
        }

        /* 0) Query-Parameter aus altem Link ---------------------------- */
        const qs   = new URLSearchParams(window.location.search);
        const lang = qs.get('lang')     || 'en';
        const ver  = qs.get('version')  || '1500';
        const prod = qs.get('product')  || 'supervisor';
        const id   = qs.get('id');

        log('Legacy-Query', { lang, ver, prod, id });
        if (!id) {
            setWaiting(false);          // kein id ⇒ Hook erledigt
            return;
        }

        /* 1) articleId bestimmen --------------------------------------- */
        let articleId = id;
        const isNumeric = /^\d+$/.test(id);

        if (isNumeric) {
            /* Wir brauchen den TOC, um parent_id → _id zu mappen */
            if (!flatToc.length) {
                log('TOC noch nicht geladen – warten …');
                return;                 // Effekt wird erneut getriggert
            }
            const node = flatToc.find(n => n.parent_id === id);
            if (!node) {                // parent_id noch nicht vorhanden
                log(`parent_id ${id} nicht gefunden`);
                return;
            }
            articleId = node._id;
            log(`parent_id ${id} ➜ _id ${articleId}`);
        } else {
            log('Hex-ID ist bereits die neue _id');
        }

        /* 2) Moderne URL bauen & redirecten ---------------------------- */
        const release = new Release({ language: lang, version: ver, product: prod });
        const newUrl = `${baseHref}/?${release.toSearchParams({ articleId }).toString()}`;
        log('Redirect ➜', newUrl);

        window.location.replace(newUrl);    // komplette Weiterleitung
        /* Kein setWaiting(false);  die Seite wird sowieso neu geladen   */
    }, [isLegacyPath, flatToc, baseHref]);

    return {
        waitingForLegacy: waiting,
        skipInitialSelect: isLegacyPath, // useContent soll beim Legacy-Pfad nichts auto-laden
    };
}
